import { getStore } from "../store/Store";
import { mutatorAction } from "satcheljs";

const onColumnHeaderWidthsUpdatedMutator: (senderColumnWidth: number, subjectColumnWidth: number, receivedColumnWidth: number, sortedContentColumnWidth: number | null) => void = mutatorAction("onColumnHeaderWidthsUpdated", (senderColumnWidth: number, subjectColumnWidth: number, receivedColumnWidth: number, sortedContentColumnWidth: number | null): void => {
    getStore().senderColumnWidth = senderColumnWidth;
    getStore().subjectColumnWidth = subjectColumnWidth;
    getStore().receivedColumnWidth = receivedColumnWidth;
    getStore().sortedContentColumnWidth = sortedContentColumnWidth;
});
export default onColumnHeaderWidthsUpdatedMutator;
